export const mayShowOrderCancel = (input: {
  isBusinessLogin: boolean;
  mayBeCancelledByCurrentBusinessMember?: boolean;
}) => !input.isBusinessLogin || input.mayBeCancelledByCurrentBusinessMember === true;

export const shouldConfirmCancellingAnotherMembersOrder = (input: {
  isBusinessLogin: boolean;
  belongsToCurrentBusinessTrader?: boolean;
  mayBeCancelledByCurrentBusinessMember?: boolean;
}) =>
  input.isBusinessLogin &&
  input.mayBeCancelledByCurrentBusinessMember === true &&
  input.belongsToCurrentBusinessTrader !== true;
